import { Component, OnInit,  Inject} from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material';
import { UserService } from 'src/app/_service/user.service';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { AlertifyService } from 'src/app/_service/alertify.service';
import { LocationService } from 'src/app/_service/location.service';


@Component({
  selector: 'app-add-location',
  templateUrl: './add-location.component.html',
  styleUrls: ['./add-location.component.css']
})
export class AddLocationComponent implements OnInit {

  authorities;
  selectedAuthority;
  newLocationName;
  level1Authorities;
  selectedLevel1Authority;

  authorityInput = { 
    rootAuthorityUnitId: null,
    parentAuthorityUnitId: null,
    name: ''
  };

  locationExists: any = {};
  locationAdded: any = {};
  model: any = {};
  newLocationAliasName: any;
  isModified = false;

  locationForm: FormGroup;

  constructor(@Inject(MAT_DIALOG_DATA) public passedData: any,
  private userService: UserService,
  private fb: FormBuilder,
  private locationService: LocationService,
  private alertify: AlertifyService,
  public dialog: MatDialog
  ) {
    this.locationForm = fb.group({

      siteFormControl: new FormControl('', [
        Validators.required
      ]),
      serviceareaFormControl: new FormControl('', [
        Validators.required
      ]),
      locationFormControl: new FormControl('', [
        Validators.required,
        this.WhitespaceValidator
      ]),
      aliasFormControl: new FormControl('', []).clearValidators(),
    });
   }

   public WhitespaceValidator(control: FormControl) {
    const isWhitespace = (control.value || '').trim().length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : { 'whitespace': true };
}


  ngOnInit() {
    this.getAllTopAuthority();
  }

  getAllTopAuthority() {
    return this.locationService.getAllTopAuthorityNames().subscribe(res => {
      this.authorities = res;
    })
  }

  getLevel1DropDown() {
    return this.locationService.levelDropDown(this.selectedAuthority).subscribe(res => {
      this.level1Authorities = res;
    });
  }

  onUserSelectTop() {
    this.getLevel1DropDown();
  }

  onUserSelectLevel1(event) {
    this.selectedLevel1Authority = event.value;
  }

  addLocation() {
    if (this.selectedAuthority && this.newLocationName && this.selectedLevel1Authority) {
      this.model.rootAuthorityUnitId = this.selectedAuthority;
      this.model.parentAuthorityUnitId = this.selectedLevel1Authority;
      this.model.name = this.newLocationName.trim();

      if (this.newLocationAliasName !== undefined) {
        this.model.alias = this.newLocationAliasName.trim();
      }
      
      return this.locationService.insertNewSite(this.model).subscribe(
        res => {
          this.locationExists = res.headers.get('locationexists');
          if (this.locationExists) {
            this.alertify.error(this.locationExists);
          }
          this.locationAdded = res.headers.get('locationadded');
          if (this.locationAdded) {
            this.alertify.success(this.locationAdded);
            this.isModified = true;
            this.dialog.closeAll();
          }
     }, error => {
             this.alertify.error('Something went wrong');
           });
        }
    } 
  }